// ============================================================
// Route constants — single source of truth for all app paths
// ============================================================

export const ROUTES = {
  // Public
  LANDING: '/',
  AUTH: '/auth',

  // Member (protected: role=member|staff|admin + active membership)
  APP: '/app',
  DASHBOARD: '/app/dashboard',
  BOOK: '/app/book',
  CAPACITY: '/app/capacity',
  EVENTS: '/app/events',
  EVENT_DETAIL: (id: string) => `/app/events/${id}`,
  COMMUNITY: '/app/community',
  REWARDS: '/app/rewards',
  WALLET: '/app/wallet',
  THREAD_DETAIL: (id: string) => `/app/community/${id}`,
  CREATE_THREAD: '/app/community/new',
  ACCESS_QR: '/app/access',
  NOTIFICATIONS: '/app/notifications',
  PROFILE: '/app/profile',

  // Admin (protected: role=admin)
  ADMIN: '/admin',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_MEMBERS: '/admin/members',
  ADMIN_BOOKINGS: '/admin/bookings',
  ADMIN_EVENTS: '/admin/events',
  ADMIN_CAPACITY: '/admin/capacity',
  ADMIN_MODERATION: '/admin/moderation',
} as const
